import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { VendorsContext } from '../../context/VendorsContext';
import { VendorMark } from '../bsa/projects/ProjectAtoms';

// Why a bug or project is in the customer's Predict scope (STRY0039118): the
// Prevent vendor whose inventory put it there and, for an open-source project,
// the managed products it was found inside. GET /predict/watchlist sends
// `inventoryVendorId` and `inventoryProducts` on every bug.

const SHOWN = 2;
const shortProduct = name => (name || '').replace(/^Red Hat Enterprise Linux /, 'RHEL ');

// "in RHEL 8, RHEL 9 +1"; empty without products.
export const inventoryLine = products => {
  const names = (Array.isArray(products) ? products : []).map(shortProduct);
  if (!names.length) return '';
  const more = names.length - SHOWN;
  return `in ${names.slice(0, SHOWN).join(', ')}${more > 0 ? ` +${more}` : ''}`;
};

// The vendor's name from the shell's vendor list; its id until the list loads.
export const useVendorName = () => {
  const [vendors] = useContext(VendorsContext) || [];
  return useMemo(() => {
    const names = new Map((Array.isArray(vendors) ? vendors : []).filter(Boolean).map(v => [v.id, v.name]));
    return id => names.get(id) || id;
  }, [vendors]);
};

const InventoryVendor = ({ vendorId, products }) => {
  const nameOf = useVendorName();
  if (!vendorId) return <span className="bz-muted">—</span>;
  const line = inventoryLine(products);
  return (
    <div className="bz-row" style={{ gap: 8, alignItems: 'flex-start' }}>
      <VendorMark vendorId={vendorId} label={nameOf(vendorId)} size={22} />
      <div style={{ minWidth: 0 }}>
        <div>{nameOf(vendorId)}</div>
        {line && (
          <div className="bz-muted" style={{ fontSize: 'var(--fs-sm)' }} title={(products || []).join(', ')}>
            {line}
          </div>
        )}
      </div>
    </div>
  );
};
InventoryVendor.propTypes = {
  vendorId: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.string)
};

export default InventoryVendor;
